import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  BookOpen, Headphones, PenTool, Mic, 
  Timer, BarChart3, Shield
} from 'lucide-react';
import { SectionHeading } from '../shared/SectionHeading';

export const FeaturesGrid: React.FC = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: BookOpen,
      titleKey: 'landing.features.reading.title',
      descriptionKey: 'landing.features.reading.description',
    },
    {
      icon: Headphones,
      titleKey: 'landing.features.listening.title',
      descriptionKey: 'landing.features.listening.description',
    },
    {
      icon: PenTool,
      titleKey: 'landing.features.writing.title',
      descriptionKey: 'landing.features.writing.description',
    },
    {
      icon: Mic,
      titleKey: 'landing.features.speaking.title',
      descriptionKey: 'landing.features.speaking.description',
    },
    {
      icon: Timer,
      titleKey: 'landing.features.timer.title',
      descriptionKey: 'landing.features.timer.description',
    },
    {
      icon: BarChart3,
      titleKey: 'landing.features.analytics.title',
      descriptionKey: 'landing.features.analytics.description',
    },
    {
      icon: Shield,
      titleKey: 'landing.features.official.title',
      descriptionKey: 'landing.features.official.description',
    },
  ];

  return (
    <section id="features" className="section-shell">
      <div className="section-container">
        <SectionHeading
          eyebrow={t('landing.features.eyebrow')}
          title={`${t('landing.features.title').split(t('landing.features.titleHighlight'))[0]} ${t('landing.features.titleHighlight')}`}
          subtitle={t('landing.features.subtitle')}
        />

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <article
                key={index}
                className="surface-card-soft p-6"
              >
                <div className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10">
                  <Icon className="h-5 w-5 text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-ink">{t(feature.titleKey)}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{t(feature.descriptionKey)}</p>
              </article>
            );
          })}
        </div>

        <div className="mt-10 text-center">
          <a href="#faq" className="text-sm font-semibold text-primary hover:underline">
            {t('landing.features.faqLink')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default FeaturesGrid;
